import React from 'react';
import JournalAdmin from './JournalAdmin';
import './AdminJournalsPage.css';

const AdminJournalsPage = () => {
  return (
    <div className="admin-journals-page">
      <div className="journals-page-header">
        <h1 className="journals-page-title">Journal Administration</h1>
        <p className="journals-page-description">
          Manage journal abbreviations and their full names. Add, edit, or delete journal entries to maintain accurate reference formatting.
        </p>
      </div>
      
      <div className="journals-page-content">
        <JournalAdmin />
      </div>
    </div>
  );
};

export default AdminJournalsPage;
